import axios from 'util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';

export const getAllCategorizedPublicTemplatesAPI = async () => {
    return await axios.get(`/api/v1/guildlibrarian/categorized-public-templates`)
        .then(function (response) {
            if (response.data) {
                return { success: true, publicTemplates: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const addUpdatePublicTemplateAPI = async (data) => {
    return await axios.post(`/api/v1/guildlibrarian/add-update-public-template`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, template: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const deletePublicTemplateAPI = async (templateId, templateName) => {
    return await axios.get(`/api/v1/guildlibrarian/delete-public-template`, {
        params: {
            templateId,
            templateName
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}